export const mainCls = 'autocmp-field-gmap';

export default {
    [`${mainCls}__cpy`]: {
        content: '',
        height: '18px',
        boxSizing: 'border-box',
        textAlign: 'right',
        display: 'block',
        backgroundImage: 'url(https://maps.gstatic.com/mapfiles/api-3/images/powered-by-google-on-white3.png)',
        backgroundPosition: 'right',
        backgroundRepeat: 'no-repeat',
        backgroundSize: '120px 14px',
    },
}